import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { MailOutline }                          from "@material-ui/icons";
import { default as React, FC }                 from "react";
import { useDispatch }                          from "react-redux";
import MenuType                                 from "../../../domain/menu/MenuType";
import RouterDispatcher                         from "../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  menuType: MenuType
}

const MenuMailButton: FC<Props> = (props: Props) => {
  const {menuType} = props;
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      {
        menuType === MenuType.MAIL
          ?
          <section className="reska-menu-selected">
            <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.mailSend() }>
              <ListItemIcon>
                <MailOutline/>
              </ListItemIcon>
              <ListItemText primary="メール送信" className="reska-menu-selected-text"/>
            </ListItem>
          </section>
          :
          <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.mailSend() }>
            <ListItemIcon>
              <MailOutline/>
            </ListItemIcon>
            <ListItemText primary="メール送信"/>
          </ListItem>
      }
    </>
  );
};

export default MenuMailButton;
